import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@ui';
import { cn } from '@utils/utils';
import EdlLogo from '@assets/edl-logo.png';
import EdlLogoSquad from '@assets/edl-logo-squad.png';
import CollapseIcon from '@assets/collapse-icon.svg';
import ExpandIcon from '@assets/expand-icon.svg';
import { changeBackground } from '@shared/utils/backgroundUtils';
import { ConfigService } from '@shared/services/config.service';

interface SidebarHeaderProps {
  isOpen: boolean;
  onToggle: () => void;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  isOpen,
  onToggle
}) => {
  const envBadge = ConfigService.getEnvironmentBadge();
  const backgroundColor = envBadge
    ? envBadge.variant === 'staging'
      ? 'bg-blue-600/50'
      : 'bg-amber-600/50'
    : 'bg-primary';
  return (
    <div className="relative border-b border-white/10 p-5">
      {/* Toggle Button */}
      <Button
        variant="ghost"
        size="icon"
        className="h-10 w-10 rounded-xl mb-4"
        onClick={onToggle}
      >
        <img 
          src={isOpen ? ExpandIcon : CollapseIcon} 
          alt={isOpen ? "Expandir menú" : "Contraer menú"}
          className="w-7"
        />
      </Button>

      <Link 
        to="/home"
        onClick={() => changeBackground('/home')}
        className={cn(
          `${backgroundColor} rounded-2xl cursor-pointer flex items-center transition-all duration-300 p-2 hover:bg-primary/80`,
          isOpen ? "p-2 justify-center" : "p-1 justify-center"
        )}
      >
        <img 
          src={isOpen ? EdlLogo : EdlLogoSquad} 
          alt="EDL Logo" 
          className={cn(
            "transition-all duration-300",
            isOpen ? "h-10 w-auto" : "h-8 w-auto"
          )} 
        />
      </Link>
    </div>
  );
};
